(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rb-product')) return;
    var OB = String.fromCharCode(123, 123), CB = String.fromCharCode(125, 125);
    var DEFAULT_FORMAT = '$' + OB + 'amount' + CB;

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '', placeholder = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}'), fmt = format || DEFAULT_FORMAT;
      function withDelimiters(number, precision, thousands, decimal) {
        thousands = thousands === undefined ? ',' : thousands; decimal = decimal === undefined ? '.' : decimal;
        if (isNaN(number) || number == null) return '0';
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), c = parts[1] ? decimal + parts[1] : '';
        return dollars + c;
      }
      var m = fmt.match(placeholder);
      switch (m ? m[1] : 'amount') {
        case 'amount': value = withDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        default: value = withDelimiters(cents, 2);
      }
      return fmt.replace(placeholder, value);
    }

    function stripHtml(s) { var d = document.createElement('div'); d.innerHTML = s; return d.textContent || ''; }

    class RbProduct extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        var sig = { signal: this.ac.signal }, self = this;
        var moneyEl = this.querySelector('[data-rb-money]');
        try { this.moneyFormat = moneyEl ? JSON.parse(moneyEl.textContent) : DEFAULT_FORMAT; } catch (e) { this.moneyFormat = DEFAULT_FORMAT; }
        this.bundles = Array.prototype.slice.call(this.querySelectorAll('[data-rb-bundle]'));
        this.form = this.querySelector('[data-rb-form]');
        this.hasSub = this.dataset.hasSub === 'true';
        this.mode = this.dataset.mode;
        this.index = parseInt(this.dataset.selected, 10) || 0;
        this.initGallery(sig);
        this.initShipDate();

        this.bundles.forEach(function (b, i) {
          b.querySelector('input').addEventListener('change', function () { self.select(i, true); }, sig);
        });
        var once = this.querySelector('[data-rb-once]'), subscribe = this.querySelector('[data-rb-subscribe]');
        if (once) once.addEventListener('click', function () { self.setMode('once'); }, sig);
        if (subscribe) subscribe.addEventListener('click', function () { self.setMode('sub'); }, sig);
        if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); }, sig);
        this.initSticky(sig);
        document.addEventListener('shopify:block:select', function (e) { self.onBlockSelect(e); }, sig);

        if (this.bundles.length) this.select(Math.min(this.index, this.bundles.length - 1), false);
        else this.render();
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.stickyObserver) this.stickyObserver.disconnect();
        if (this.stickyResize) this.stickyResize.disconnect();
        if (this.sticky && this.sticky.parentElement === document.body) this.sticky.remove();
        if (this.stickySpacer) this.stickySpacer.remove();
        document.documentElement.classList.remove('rb-sticky-on');
      }

      /* Sticky add to cart: shows as soon as the main button has scrolled out of view above, and stays visible down to the footer. */
      initSticky(sig) {
        var self = this;
        this.sticky = this.querySelector('[data-rb-sticky]');
        if (!this.sticky) return;
        this.stickyBtn = this.sticky.querySelector('[data-rb-sticky-btn]');
        // Move the bar to <body> so no transformed or overflow-clipped ancestor can break position: fixed.
        document.body.appendChild(this.sticky);
        this.stickyBtn.addEventListener('click', function () { self.addToCart(true); }, sig);
        // Spacer at the end of the page so the bar never covers the last lines of the footer.
        var footer = document.querySelector('.page-wrapper > footer') || document.querySelector('footer');
        if (footer) {
          this.stickySpacer = document.createElement('div');
          this.stickySpacer.className = 'rb-sticky-spacer';
          this.stickySpacer.setAttribute('aria-hidden', 'true');
          footer.appendChild(this.stickySpacer);
        }
        var setHeight = function () { document.documentElement.style.setProperty('--rb-sticky-h', self.sticky.offsetHeight + 'px'); };
        setHeight();
        if ('ResizeObserver' in window) { this.stickyResize = new ResizeObserver(setHeight); this.stickyResize.observe(this.sticky); }
        var atc = this.querySelector('[data-rb-atc]');
        this.atcAbove = false;
        if (!atc) return;
        if (!('IntersectionObserver' in window)) { this.atcAbove = true; this.toggleSticky(); return; }
        this.stickyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self.atcAbove = !en.isIntersecting && en.boundingClientRect.bottom <= 0; });
          self.toggleSticky();
        }, { threshold: 0 });
        this.stickyObserver.observe(atc);
      }

      toggleSticky() {
        if (!this.sticky) return;
        var show = !!this.atcAbove;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.stickyBtn.tabIndex = show ? 0 : -1;
        document.documentElement.classList.toggle('rb-sticky-on', show);
      }

      renderSticky(b, sub) {
        if (!this.sticky || !b) return;
        var now = this.sticky.querySelector('[data-rb-sticky-now]'), price = this.sticky.querySelector('[data-rb-sticky-price]');
        var label = this.sticky.querySelector('[data-rb-sticky-label]'), stock = this.sticky.querySelector('[data-rb-sticky-stock]');
        var final = this.prices(b, sub).now;
        var available = b.dataset.available === 'true';
        var variant = this.sticky.querySelector('[data-rb-sticky-variant]');
        if (variant && b.dataset.title) { variant.textContent = b.dataset.title; variant.hidden = false; }
        now.textContent = this.money(final);
        price.hidden = !available;
        if (stock) stock.hidden = !available;
        label.textContent = available ? this.stickyBtn.dataset.label : (this.stickyBtn.dataset.soldout || this.stickyBtn.dataset.label);
        this.stickyBtn.disabled = !available;
        this.stickyBtn.setAttribute('aria-label', available ? label.textContent + ' - ' + now.textContent : label.textContent);
      }

      showStickyError(msg) {
        if (!this.sticky) return;
        var el = this.sticky.querySelector('[data-rb-sticky-error]');
        el.textContent = msg || ''; el.hidden = !msg;
        clearTimeout(this.stickyErrTimer);
        if (msg) this.stickyErrTimer = setTimeout(function () { el.hidden = true; }, 5000);
      }

      money(c) { return formatMoney(c, this.moneyFormat); }

      current() { return this.bundles[this.index] || null; }

      /* Price shown, and the crossed-out "before" price (0 when there is no saving). */
      prices(b, sub) {
        var price = +b.dataset.price, compare = +b.dataset.compare || 0, subp = +b.dataset.sub;
        var now = sub ? subp : price;
        var was = sub ? Math.max(price, compare) : compare;
        return { now: now, was: was > now ? was : 0 };
      }

      select(i, fromUser) {
        this.index = i;
        this.bundles.forEach(function (b, j) {
          b.classList.toggle('is-selected', j === i);
          b.querySelector('input').checked = j === i;
        });
        var b = this.current();
        if (b && fromUser) {
          if (b.dataset.media) this.showMedia(b.dataset.media);
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', b.dataset.variant);
            window.history.replaceState(window.history.state, '', url.toString());
          } catch (e) {}
        }
        this.render();
      }

      setMode(mode) {
        if (!this.hasSub) mode = 'once';
        this.mode = mode;
        this.dataset.mode = mode;
        this.render();
        var target = this.querySelector(mode === 'sub' ? '[data-rb-once]' : '[data-rb-subscribe]');
        if (target && document.activeElement && document.activeElement.closest && document.activeElement.closest('.rb-toggle')) target.focus();
      }

      render() {
        var self = this, sub = this.mode === 'sub' && this.hasSub;
        this.bundles.forEach(function (b) {
          var pr = self.prices(b, sub);
          b.querySelector('[data-rb-bnow]').textContent = self.money(pr.now);
          var was = b.querySelector('[data-rb-bwas]'), save = b.querySelector('[data-rb-save]');
          was.textContent = pr.was ? self.money(pr.was) : ''; was.hidden = !pr.was;
          if (save) {
            save.textContent = (save.dataset.prefix ? save.dataset.prefix + ' ' : '') + self.money(pr.was - pr.now);
            save.hidden = !pr.was;
          }
        });
        var heading = this.querySelector('[data-rb-heading]');
        if (heading) heading.textContent = sub ? heading.dataset.sub : heading.dataset.once;

        var b = this.current(), atc = this.querySelector('[data-rb-atc]');
        var idInput = this.querySelector('[data-rb-id]'), planInput = this.querySelector('[data-rb-plan]');
        var compare = this.querySelector('[data-rb-compare]'), now = this.querySelector('[data-rb-now]'), pct = this.querySelector('[data-rb-savepct]');
        if (b) {
          var pr = this.prices(b, sub), final = pr.now;
          idInput.value = b.dataset.variant;
          if (sub && b.dataset.plan) { planInput.value = b.dataset.plan; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
          if (now) now.textContent = this.money(final);
          if (compare && pct) {
            if (pr.was) {
              compare.textContent = this.money(pr.was);
              pct.textContent = 'SAVE ' + Math.floor((pr.was - final) / pr.was * 100) + '%';
              pct.hidden = false;
            } else { compare.textContent = ''; pct.hidden = true; }
          }
          var available = b.dataset.available === 'true';
          atc.disabled = !available;
          atc.textContent = available ? atc.dataset.label : (atc.dataset.soldout || atc.dataset.label);
          var delivery = this.querySelector('[data-rb-delivery]'), refill = this.querySelector('[data-rb-refill]');
          if (delivery) { delivery.textContent = b.dataset.delivery; delivery.closest('li').hidden = !b.dataset.delivery; }
          if (refill) {
            var line = b.dataset.refillLine || '';
            refill.textContent = line.replace('[refill_price]', this.money(+b.dataset.refill));
            refill.closest('li').hidden = !line;
          }
        }
        this.renderSticky(b, sub);
        var subinfo = this.querySelector('[data-rb-subinfo]'), once = this.querySelector('[data-rb-once]'), subBtn = this.querySelector('[data-rb-subscribe]');
        if (subinfo) subinfo.hidden = !sub;
        if (once) once.hidden = !sub;
        if (subBtn) subBtn.hidden = sub;
      }

      initShipDate() {
        var el = this.querySelector('[data-rb-ship]');
        if (!el) return;
        var d = new Date(); d.setDate(d.getDate() + (parseInt(this.dataset.shipDays, 10) || 0));
        var text = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        el.textContent = stripHtml(el.dataset.template).replace('[date]', text);
      }

      initGallery(sig) {
        var self = this;
        this.track = this.querySelector('[data-rb-track]');
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.rb-gallery__thumb'));
        this.prev = this.querySelector('[data-rb-prev]');
        this.next = this.querySelector('[data-rb-next]');
        if (!this.track) return;
        this.slides = Array.prototype.slice.call(this.track.children);
        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () { ticking = false; self.syncGallery(); });
        }, Object.assign({ passive: true }, sig));
        this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.goTo(i); }, sig); });
        if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.slideIndex() - 1); }, sig);
        if (this.next) this.next.addEventListener('click', function () { self.goTo(self.slideIndex() + 1); }, sig);
        this.syncGallery();
      }

      slideIndex() { return this.track ? Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)) : 0; }

      goTo(i) {
        if (!this.track || !this.slides.length) return;
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        this.setActiveThumb(i);
      }

      showMedia(mediaId) {
        var idx = this.slides ? this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); }) : -1;
        if (idx > -1) this.goTo(idx);
      }

      setActiveThumb(i) {
        this.thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        var t = this.thumbs[i], row = t && t.parentElement;
        if (t && row && (t.offsetLeft < row.scrollLeft || t.offsetLeft + t.offsetWidth > row.scrollLeft + row.clientWidth)) {
          row.scrollTo({ left: t.offsetLeft - 15, behavior: 'smooth' });
        }
      }

      syncGallery() {
        var i = this.slideIndex();
        this.setActiveThumb(i);
        if (this.prev) this.prev.hidden = i <= 0;
        if (this.next) this.next.hidden = i >= this.slides.length - 1;
      }

      onBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        var self = this;
        this.bundles.forEach(function (b, i) { if (b.dataset.blockId === e.detail.blockId) self.select(i, true); });
        var acc = this.querySelector('details[data-block-id="' + e.detail.blockId + '"]');
        if (acc) acc.open = true;
      }

      cartSectionIds() {
        var ids = [];
        document.querySelectorAll('cart-items-component, [data-section-type="cart-drawer"], mc-cart-drawer').forEach(function (el) {
          var id = el.dataset.sectionId;
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
        return ids;
      }

      showError(msg) {
        var el = this.querySelector('[data-rb-error]');
        if (!el) return;
        el.textContent = msg || '';
        el.hidden = !msg;
      }

      async addToCart(fromSticky) {
        var b = this.current(), atc = this.querySelector('[data-rb-atc]');
        var variantId = b ? b.dataset.variant : this.querySelector('[data-rb-id]').value;
        if (!variantId || atc.disabled || atc.classList.contains('is-loading')) return;
        this.showError(''); this.showStickyError('');
        var sbtn = this.stickyBtn;
        atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true');
        if (sbtn) { sbtn.classList.add('is-loading'); sbtn.setAttribute('aria-busy', 'true'); }
        var item = { id: Number(variantId), quantity: 1 };
        var planInput = this.querySelector('[data-rb-plan]');
        if (!planInput.disabled && planInput.value) item.selling_plan = Number(planInput.value);
        var sectionIds = this.cartSectionIds();
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          var body = { items: [item] };
          if (sectionIds.length) { body.sections = sectionIds.join(','); body.sections_url = window.location.pathname; }
          var res = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
          var cartRes = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          var cart = await cartRes.json();
          var opened = await this.notifyTheme(data, cart, item, sectionIds);
          if (!opened) window.location.href = root + 'cart';
        } catch (err) {
          var msg = err && err.message ? err.message : 'Could not add to cart. Please try again.';
          this.showError(msg);
          if (fromSticky) this.showStickyError(msg);
        } finally {
          atc.classList.remove('is-loading'); atc.removeAttribute('aria-busy');
          if (sbtn) { sbtn.classList.remove('is-loading'); sbtn.removeAttribute('aria-busy'); }
        }
      }

      /* Tells Horizon the cart changed (current and older versions), then opens the drawer. Returns false if no drawer exists. */
      async notifyTheme(addResponse, cart, item, sectionIds) {
        var sections = addResponse.sections || {};
        var detail = { items: cart.items, source: 'rb-product', sourceId: this.id, itemCount: item.quantity, productId: this.dataset.productId, sections: sections, didError: false };
        var notified = false;
        try {
          var themeEvents = await import('@theme/events');
          if (themeEvents && themeEvents.CartAddEvent) {
            this.dispatchEvent(new themeEvents.CartAddEvent({}, this.id, detail));
            notified = true;
          }
        } catch (e) {}
        if (!notified) {
          try {
            var std = await import('@shopify/events');
            if (std && std.CartLinesUpdateEvent) {
              var deferred = std.CartLinesUpdateEvent.createPromise();
              this.dispatchEvent(new std.CartLinesUpdateEvent({
                action: 'add', context: 'product', lines: [{ merchandiseId: String(item.id), quantity: item.quantity }], promise: deferred.promise
              }));
              deferred.resolve({ cart: std.CartLinesUpdateEvent.createCartFromAjaxResponse ? std.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : cart, detail: detail });
              notified = true;
            }
          } catch (e) {}
        }
        if (document.querySelector('mc-cart-drawer')) return notified;
        var drawerContent = document.querySelector('cart-drawer-component');
        if (!drawerContent) return notified && document.querySelector('cart-items-component') !== null ? true : false;
        await new Promise(function (r) { setTimeout(r, 60); });
        var drawer = drawerContent.closest('theme-drawer');
        try {
          if (drawer && typeof drawer.open === 'function') { if (!drawer.hasAttribute('open') && !drawer.isOpen) drawer.open(); }
          else if (typeof drawerContent.open === 'function') drawerContent.open();
          else if (typeof drawerContent.showDialog === 'function') drawerContent.showDialog();
          else { var dlg = drawerContent.closest('dialog') || drawerContent.querySelector('dialog'); if (dlg && !dlg.open) dlg.showModal(); }
        } catch (e) {}
        return true;
      }
    }

    customElements.define('rb-product', RbProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rh-announcement')) return;
    class RhAnnouncement extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('.rh-ann__item'));
        this.index = 0;
        this.ac = new AbortController();
        var sig = { signal: this.ac.signal };
        this.addEventListener('mouseenter', function () { self.stop(); }, sig);
        this.addEventListener('mouseleave', function () { self.start(); }, sig);
        document.addEventListener('shopify:block:select', function (e) {
          if (!e.detail || e.detail.sectionId !== self.dataset.sectionId) return;
          var i = self.items.findIndex(function (n) { return n.dataset.blockId === e.detail.blockId; });
          if (i > -1) { self.stop(); self.show(i); }
        }, sig);
        document.addEventListener('shopify:block:deselect', function () { self.start(); }, sig);
        this.start();
      }
      disconnectedCallback() { this.stop(); if (this.ac) this.ac.abort(); }
      show(i) {
        this.index = (i + this.items.length) % this.items.length;
        var idx = this.index;
        this.items.forEach(function (n, j) { n.classList.toggle('is-active', j === idx); n.setAttribute('aria-hidden', j === idx ? 'false' : 'true'); });
      }
      start() {
        var self = this; this.stop();
        if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(function () { self.show(self.index + 1); }, (parseInt(this.dataset.speed, 10) || 5) * 1000);
      }
      stop() { clearInterval(this.timer); }
    }
    customElements.define('rh-announcement', RhAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rh-header')) return;
    class RhHeader extends HTMLElement {
      connectedCallback() {
        var self = this; this.ac = new AbortController(); var sig = { signal: this.ac.signal };
        this.menu = this.querySelector('[data-rh-menu]'); this.search = this.querySelector('[data-rh-search]');
        this.burger = this.querySelector('[data-rh-open-menu]');
        this.searchBtn = this.querySelector('[data-rh-open-search]');
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-rh-open-menu]')) { self.menu && !self.menu.hidden ? self.closeMenu() : self.openMenu(); }
          else if (e.target.closest('[data-rh-open-search]')) self.toggleSearch(true);
          else if (e.target.closest('[data-rh-close-search]')) self.toggleSearch(false);
        }, sig);
        this.querySelectorAll('[data-rh-autosubmit]').forEach(function (sel) { sel.addEventListener('change', function () { sel.form.submit(); }, sig); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.closeMenu(); self.toggleSearch(false); } }, sig);
        window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) self.closeMenu(); }, sig);
        import('@shopify/events').then(function (mod) {
          if (!mod || !mod.StandardEvents || !self.ac || self.ac.signal.aborted) return;
          document.addEventListener(mod.StandardEvents.cartLinesUpdate, function (e) {
            if (!e.promise || !e.promise.then) return;
            e.promise.then(function (r) { var c = r && r.cart; if (c && typeof c.totalQuantity === 'number') self.setCount(c.totalQuantity); }).catch(function () {});
          }, sig);
        }).catch(function () {});
        document.addEventListener('cart:update', function (e) { var d = e.detail && e.detail.data; if (d && typeof d.itemCount === 'number') self.refreshCount(); }, sig);
        document.addEventListener('rh:cart-count', function (e) { if (e.detail && typeof e.detail.count === 'number') self.setCount(e.detail.count); }, sig);
      }
      disconnectedCallback() { if (this.ac) this.ac.abort(); document.documentElement.classList.remove('rh-lock'); }
      setCount(n) {
        var b = this.querySelector('[data-rh-cart-count]'); if (!b) return;
        b.textContent = n; b.hidden = !n;
        var link = b.closest('a'); if (link) link.setAttribute('aria-label', 'Cart, ' + n + ' items');
      }
      refreshCount() {
        var self = this;
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); }).then(function (c) { self.setCount(c.item_count); }).catch(function () {});
      }
      openMenu() {
        if (!this.menu) return;
        this.toggleSearch(false);
        var top = this.getBoundingClientRect().bottom;
        this.style.setProperty('--rh-drawer-top', Math.max(0, top) + 'px');
        this.menu.hidden = false; document.documentElement.classList.add('rh-lock');
        if (this.burger) { this.burger.setAttribute('aria-expanded', 'true'); this.burger.setAttribute('aria-label', 'Close menu'); }
      }
      closeMenu() {
        if (!this.menu || this.menu.hidden) return;
        this.menu.hidden = true; document.documentElement.classList.remove('rh-lock');
        if (this.burger) { this.burger.setAttribute('aria-expanded', 'false'); this.burger.setAttribute('aria-label', 'Open menu'); }
      }
      toggleSearch(force) {
        if (!this.search) return;
        var open = typeof force === 'boolean' ? force : this.search.hidden;
        if (open === !this.search.hidden) return;
        if (open) this.closeMenu();
        this.search.hidden = !open;
        document.documentElement.classList.toggle('rh-lock', open);
        if (this.searchBtn) this.searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = this.search.querySelector('input[type="search"]'); if (i) i.focus(); }
        else if (this.searchBtn && this.contains(document.activeElement)) this.searchBtn.focus();
      }
    }
    customElements.define('rh-header', RhHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rh-products')) return;
    var EVENTS = import('@shopify/events').catch(function () { return null; });
    class RhProducts extends HTMLElement {
      connectedCallback() {
        var self = this; this.ac = new AbortController();
        this.addEventListener('click', function (e) { var b = e.target.closest('[data-rh-add]'); if (b && !b.disabled) self.add(b); }, { signal: this.ac.signal });
      }
      disconnectedCallback() { if (this.ac) this.ac.abort(); }
      async add(btn) {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var err = btn.parentElement.querySelector('[data-rh-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        btn.classList.add('is-loading'); btn.disabled = true; btn.textContent = this.dataset.adding || btn.dataset.label;
        var ids = []; document.querySelectorAll('mc-cart-drawer, cart-items-component').forEach(function (n) { if (n.dataset.sectionId && ids.indexOf(n.dataset.sectionId) < 0) ids.push(n.dataset.sectionId); });
        try {
          var body = { items: [{ id: Number(btn.dataset.variant), quantity: 1 }] };
          if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
          var res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
          var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
          var mod = await EVENTS, handled = false;
          if (mod && mod.CartLinesUpdateEvent) {
            var d = mod.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(btn.dataset.variant), quantity: 1 }], promise: d.promise }));
            d.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse ? mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : cart, detail: { items: cart.items, source: 'rh-products', itemCount: 1, sections: data.sections || {}, didError: false } });
            handled = !!document.querySelector('mc-cart-drawer, cart-drawer-component');
          }
          if (!handled) { if (typeof window.openCartDrawer === 'function') window.openCartDrawer(); else window.location.href = root + 'cart'; }
          btn.textContent = this.dataset.added || btn.dataset.label;
          setTimeout(function () { btn.textContent = btn.dataset.label; }, 1500);
        } catch (e) {
          btn.textContent = btn.dataset.label;
          if (err) { err.textContent = e.message; err.hidden = false; }
        } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
      }
    }
    customElements.define('rh-products', RhProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rh-tabs')) return;
    class RhTabs extends HTMLElement {
      connectedCallback() {
        var self = this; this.ac = new AbortController(); var sig = { signal: this.ac.signal };
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-rh-tab]'));
        this.tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { self.select(i, false); }, sig);
          t.addEventListener('keydown', function (e) {
            var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? self.tabs.length - 1 : null;
            if (n === null) return; e.preventDefault(); self.select((n + self.tabs.length) % self.tabs.length, true);
          }, sig);
        });
        document.addEventListener('shopify:block:select', function (e) {
          if (!e.detail || e.detail.sectionId !== self.dataset.sectionId) return;
          var i = self.tabs.findIndex(function (t) { return t.dataset.blockId === e.detail.blockId; });
          if (i > -1) self.select(i, false);
        }, sig);
      }
      disconnectedCallback() { if (this.ac) this.ac.abort(); }
      select(i, focus) {
        this.tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        this.querySelectorAll('[data-rh-panel]').forEach(function (p) { p.hidden = String(i) !== p.dataset.rhPanel; });
        var t = this.tabs[i];
        if (t) { if (focus) t.focus(); if (t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
      }
    }
    customElements.define('rh-tabs', RhTabs);
  })();

  } catch(e) { console.error(e); }
})();
})();
